<template>
    <div>
        <table class="table">
            <thead>
            <tr>
                <th v-for="column of columns" :key="column.id">
                    <div v-if="column.type === 'checkbox'">
                        <input type="checkbox" v-model="all" @change="updateSelected" />
                    </div>
                    <div>
                        {{ column.name }}
                        <ExpertPanelTableFilter
                            v-if="column.filter"
                            :value="filter[column.filter.params.alias]"
                            @apply="applyFilter"
                            @clear="clearFilterParam(column.filter.params.alias)"
                        >
                            <component
                                :is="column.filter.type"
                                :params="column.filter.params"
                                v-model="inputFilter[column.filter.params.alias]"
                            />
                        </ExpertPanelTableFilter>
                    </div>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row of rows" :key="row.id" @click="$emit('click', row)">
                <td v-for="column of columns" :key="`${row.id}-${column.id}`">
                    <div v-if="column.type === 'checkbox'">
                        <input
                            v-if="!all"
                            type="checkbox"
                            v-model="selected[row.id]"
                            @change.stop="updateSelected"
                            @click.stop=""
                        />
                    </div>
                    <div v-else class="cell-content">
                        {{ column.value(row) }}
                        <Tooltip class="info" v-if="column.infoBadge && column.infoBadge(row)">
                            <template>
                                <img src="@/assets/images/expert-panel/info.svg" />
                            </template>
                            <template v-slot:tooltip>
                                Оценки экспертов неравнозначны. Рекомендуется дополнительная проверка.
                            </template>
                        </Tooltip>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import Tooltip from "@/components/UI/Tooltip.vue";
import ExpertPanelTableFilter from "@/components/expert-panel-new/tables/ExpertPanelTableFilter.vue";
import FilterInput from "@/components/expert-panel-new/tables/filters/FilterInput.vue";

export default {
    name: "ExpertPanelTable",
    components: { FilterInput, ExpertPanelTableFilter, Tooltip },
    props: {
        columns: Array,
        rows: Array,
        filter: Object,
    },
    emits: ['click', 'updateFilter', 'select'],
    data() {
        return {
            all: true,
            selected: {},
            inputFilter: {...this.filter},
        };
    },
    watch: {
        filter() {
            this.inputFilter = {...this.filter};
        },
    },
    methods: {
        applyFilter() {
            this.$emit('updateFilter', this.inputFilter);
        },
        clearFilterParam(param) {
            this.inputFilter[param] = '';
            this.$emit('updateFilter', this.inputFilter);
        },
        updateSelected() {
            if (this.all) {
                this.$emit('select', 'all');
            } else {
                this.$emit('select', Object.keys(this.selected).reduce((res, item) => {
                    if (this.selected[item]) {
                        res.push(+item);
                    }
                    return res;
                }, []));
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

.table {
  width: 100%;
  border: solid 1px #D2D5D9;
  border-radius: rem(10);
  border-spacing: 0;
  border-collapse: separate;
  thead {
    th, td {
      border-top: 0;
    }
  }
  tbody {
    tr {
      &:hover {
        cursor: pointer;
        td {
          background: #F6FAFD;
          color: #4663AB;
        }
      }
    }
  }
  th {
    padding: rem(16);
    text-align: left;
    font-weight: 600;
    font-size: rem(16);
    line-height: rem(22);
    border-top: solid 1px #D2D5D9;
    border-left: solid 1px #D2D5D9;
    &:first-child {
      border-left: 0;
    }
    div {
      display: flex;
      gap: rem(8);
    }
  }
  td {
    padding: rem(32) rem(16);
    border-top: solid 1px #D2D5D9;
    border-left: solid 1px #D2D5D9;
    &:first-child {
      border-left: 0;
    }
  }
  &__filter-icon {
    cursor: pointer;
  }
  input[type=checkbox] {
    width: rem(20);
    height: rem(20);
  }
}

.cell-content {
  display: flex;
  align-items: center;
  gap: 6px;
}
</style>